export const AWSEndpoints = {
  BILLING_INVOICE: '/billing/invoice',
  BILLING_DEBT_INVOICE: '/billing/debt-invoice',
};
